import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'

import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import colors from '../../../../assets/colors'

// Confirmação do módulo de assinatura no padrão BaseFilterModal (mesma ideia do
// ItemConfirmModal do attendance, que substituiu o useConfirm por lá).
// `confirm` é o pedido em aberto: { title, description, confirmationText,
// cancellationText, danger, onConfirm } — null fecha o modal.
const ConfirmModal = ({ confirm, onClose = () => {}, width = '360px' }) => {
  const classes = filterStylesComponents()

  const handleConfirm = () => {
    if (confirm?.onConfirm) confirm.onConfirm()
    onClose()
  }

  return (
    <BaseFilterModal
      open={!!confirm}
      title={confirm?.title || 'Tem certeza?'}
      hiddenHelpButton
      handleOpen={onClose}
    >
      <Grid item xs={12} style={{ width }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography style={{ color: colors.textGray }}>
              {confirm?.description}
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            container
            alignItems="center"
            justifyContent="flex-end"
          >
            <Button
              type="button"
              onClick={onClose}
              className={classes.btnMoreFilters}
            >
              {confirm?.cancellationText || 'Voltar'}
            </Button>

            <Button
              type="button"
              onClick={handleConfirm}
              className={classes.btnAdd}
              style={
                confirm?.danger ? { backgroundColor: colors.error } : undefined
              }
            >
              {confirm?.confirmationText || 'Confirmar'}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}

export default ConfirmModal
